import { connectorApiClient } from '@/shared/api/core/axios-instance';

import type { Connector } from '@/entities/connector/types';

export const getConnectorApi = async (id: string): Promise<Connector> => {
  const { data } = await connectorApiClient.get<Connector>(`/connectors/${id}`);
  return data;
};
